import React from 'react';
import './Filter.scss';
import { IFilterProps } from './IFilterProps';
import IRefiner from '../../../Models/IRefiner';
import IFilterState from './IFilterState';
import { DisplayFormat } from '../../../Models/DisplayFormat';
import { SearchSource } from '../../LPVSok/getResults';
import { Log } from '../../../utils/logging';
import { getUrlParameter, setUrlParameter } from '../../../utils/urlParamHelper';
import { Heading, Button, Dialog } from '@udir-design/react/beta';
import { Details } from '@udir-design/react/beta';
import { Checkbox } from '@udir-design/react/beta';
import { FilterIcon } from '@udir-design/icons';

export default class Filter extends React.Component<IFilterProps, IFilterState> {
    private collapsedFilterThreshold = 7;
    
    public constructor(props) {
        super(props);
        console.log(props);
        const initialFilterKeys = this.setupInitialFilterKeys();
        const initialCollapsedFilters = this.setupInitialCollapsedFilters();
        this.state = {
            openFilterKeys: initialFilterKeys,
            collapsedFilters: initialCollapsedFilters,
            isMobileOpen: this.props.initialMobileOpen ?? this.props.isOpenOnPageLoad ?? false,
            hiddenFilterNames: []
        };
    }

    private setupInitialCollapsedFilters(){
        let collapsedFilters: string[] = [];
        this.props.refiners.forEach(refiner => {
            collapsedFilters.push(refiner.Name);
        });
        return collapsedFilters;
    }

    private setupInitialFilterKeys() {
        const validNames = new Set(this.props.refiners.map(r => r.Name));
        if (this.props.initialOpenFilterNames !== undefined) {
            // Only keep names that exist in refiners
            const unique = Array.from(new Set(this.props.initialOpenFilterNames));
            return unique.filter(name => validNames.has(name));
        }
        if (this.props.displayFormat === DisplayFormat.Desktop) {
            // Default: open all groups on desktop so options are visible
            return this.props.refiners.map(refiner => refiner.Name);
        }
        return [];
    }

    public componentDidUpdate(prevProps: IFilterProps) {
        // Close mobile dialog when navigating between pages (refiners array changes completely)
        // Check if the refiner names changed (different page), not just the values (filter selection)
        const prevRefinerNames = prevProps.refiners.map(r => r.Name).sort().join(',');
        const currentRefinerNames = this.props.refiners.map(r => r.Name).sort().join(',');
        
        if (prevRefinerNames !== currentRefinerNames && this.state.isMobileOpen) {
            this.setState({ isMobileOpen: false });
        }
    }

    public render() {
        console.log(this.props);
        if (this.props.displayFormat === DisplayFormat.Desktop) {
            return this.renderDesktopVersion();
        } else {
            return this.renderMobileVersion();
        }
    }

    private renderDesktopVersion() {
        
        return (
            
            <div className="filterOuterContainer">
                <Heading level={2} data-size='sm'>Filtrer søket</Heading>
                {this.props.filterChips}
                <div className="filterContainer">
                    {this.props.refiners.map((refiner, idx) =>
                        this.renderFilterGroup(refiner.Name, refiner.Entries, idx, false)
                    )}
                    {/* 
                        {this.renderSourceToggle(false)}
                    */}
                    {/* NOT IN USE
                    {this.props.source !== undefined && (
                        <Checkbox
                            className='IncludeAll'
                            description={this.props.totalResults !== undefined ? `(${this.props.totalResults})` : undefined}
                            id="checkbox-preview"
                            label="Inkluder utgåtte versjoner"
                            checked={this.props.source === SearchSource.All}
                            onChange={() => this.onSourceButtonPressed()}
                            value="include-utgatt"
                        />
                    )}
                    */}
                </div>
                
            </div>
        );
    }

    private renderMobileVersion() {
        console.log("renderMobileVersion - renderMobileVersion - renderMobileVersion");
        if (!this.props.refiners || this.isEmpty(this.props.refiners)) return null;
        const isOpen = this.state.isMobileOpen;
        
        return (
            <div className="filterContainer mobileFilterContainer">
                <Button onClick={() => this.toggleMobileAccordion()} variant="secondary">
                    <FilterIcon aria-label="Filtrer søket" />
                    Filtrer søket
                </Button>

                <Dialog open={isOpen} closedby="any" onClose={() => this.setState({ isMobileOpen: false })}>
                    <Dialog.Block>
                        <Heading className="filter-title-modal" level={2}>Filtrer søket</Heading>
                        {this.props.refiners.map((refiner, idx) => {
                            return this.renderFilterGroup(refiner.Name, refiner.Entries, idx, true);
                        })}
                       
                        <Button className="filter-close-modal" onClick={() => this.toggleMobileAccordion()} variant="primary">
                            Lukk
                        </Button>
                    </Dialog.Block>
                </Dialog>
            </div>
        );
    }

    private renderFilterGroup = (filterName: string, filters: IRefiner[], idx: number, isMobile: boolean) => {
        const isOpen = this.state.openFilterKeys.indexOf(filterName) > -1;
        
        return (
                <Details key={`filter-group-${filterName}-${idx}`} open={isOpen} onToggle={() => this.toggleAccordion(filterName)} className='search-accordion__title' data-color='support1'>
                    <Details.Summary className='search-filter__summary' data-color="support1">
                        <Heading level={3} className='search-filter__title'>{this.props.getFilterDisplayName(filterName)}</Heading>
                    </Details.Summary>
                    <Details.Content>
                        <div className="filter-checkboxes">
                            {filters.map((filter, i) => {
                                const isIndentedClass: string = filter.indentation ? 'checkboxIndetation' : '';
                                const isChecked = (filter.checked === true) || (filter.fakeChecked === true);
                                const isHiddenClass = (filter.hidden && !isChecked) ? 'is-hidden' : '';
                                const combinedClass = `checkBox ${isIndentedClass} ${isHiddenClass}`.trim();
                                
                                const labelWithCount = `${filter.RefinementName}${filter.RefinementCount !== undefined ? ` (${filter.RefinementCount})` : ''}`;
                                return (
                                    <div className={combinedClass} key={`checkbox-${i}`}>
                                        <Checkbox
                                            className='checkbox-container'
                                            id={`checkBoxInput-${filterName}-${i}`}
                                            label={labelWithCount}
                                            checked={isChecked}
                                            onChange={() => this.onCheckBoxmarked(filterName, i)}
                                            value={String(filter.RefinementValue ?? '')}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </Details.Content>
                </Details>
            
        );
    };

    private toggleMobileAccordion() {
        const isOpen = !this.state.isMobileOpen;
        this.setState({
            isMobileOpen: isOpen
        });
    }

    private toggleShowMore(filters: IRefiner[], filterName: string){
        let collapsedFilt = this.state.collapsedFilters.slice();
        if (collapsedFilt.indexOf(filterName) > -1) {
            collapsedFilt = collapsedFilt.filter(key => key !== filterName);
        } else {
            collapsedFilt.push(filterName);
        }
        this.setState({
            collapsedFilters: collapsedFilt
        });
    }

    private displayShowMoreButton = (filters: IRefiner[], filterName: string) => {
        let showMoreLessText = this.state.collapsedFilters.indexOf(filterName) > -1 ? "Vis mer" : "Vis mindre";
        const showMoreClass = this.state.collapsedFilters.indexOf(filterName) > -1 ? "more" : "less";
        //Log(filters.length);
        //Log(this.collapsedFilterThreshold);
        //Log("------------------------" + filterName);
        //dont show show more/less for certain filters
        if(filters.length > this.collapsedFilterThreshold+1 && ["fltypefiltermulti", "utdanningsprogram", "ExCatalogTypeName", "nivaa"].indexOf(filterName) === -1){
            return(
                <button className={`accordion-button btn ${showMoreClass}`}
                    onClick={filterName ? () => this.toggleShowMore(filters, filterName) : () => this.toggleShowMore(filters,filterName)}
                >
                    <span className={`accordion-open`}>{showMoreLessText}</span>
                    
                </button>
            );
        }
    }

    private renderCheckBoxesNew = (filters: IRefiner[], filterName: string) => {
        const elements: JSX.Element[] = [];

        // Individual filter entries
        filters.forEach((filter, idx) => {
            const isChecked = (filter.checked === true) || (filter.fakeChecked === true);
            const id = `checkbox-${filterName}-${idx}`;

            elements.push(
                <Checkbox
                    id={id}
                    value= "KAAAKS"
                    checked={isChecked}
                    onChange={() => this.onCheckBoxmarked(filterName, idx)}
                />
            );
        });

        return elements;
    }

    private renderCheckBoxes = (filters: IRefiner[], filterName: string) => {
        let checkBoxes = filters.map((filter, idx) => {
            const isChecked = ((filter.checked !== undefined && filter.checked === true) || (filter.checked !== undefined && filter.fakeChecked === true));
            const count = filter.RefinementCount !== undefined ? ` (${filter.RefinementCount})` : '';
            const isHiddenClass = (((filters.length >= this.collapsedFilterThreshold && idx > this.collapsedFilterThreshold && this.state.collapsedFilters.indexOf(filterName) > -1) && ["fltypefiltermulti", "utdanningsprogram", "ExCatalogTypeName", "nivaa"].indexOf(filterName) === -1) || (filter.hidden && !filter.checked)) ? 'is-hidden' : '';
            const isIndentedClass: string = filter.indentation ? 'checkboxIndetation' : '';
            
            return (
                <div className={`checkBox ${isIndentedClass} ${isHiddenClass}`} key={`checkbox-${idx}`}>
                    <Checkbox
                        value={`${filterName}-${idx}`}
                        checked={isChecked}
                        onChange={() => this.onCheckBoxmarked(filterName, idx)}
                    >
                        {`${filter.RefinementName}${count}`}
                    </Checkbox>
                </div>
            );
        });

        checkBoxes.unshift(
            <div className={`checkBox Alle`} key={`checkbox-${'-1'}`}>
                <Checkbox
                    value={`${filterName}-all`}
                    checked={filters.filter(filter => filter.checked).length === 0}
                    onChange={() => this.onAllFiltersClicked(filterName)}
                >
                    {`Alle - ${this.props.getFilterDisplayName(filterName)}`}
                </Checkbox>
            </div>
        );
        return checkBoxes;
    };

    private onCheckBoxmarked(refinerName: string, refinerIndex: number) {
        // Handle parent/child visibility for hierarchical filters
        const refiner = this.props.refiners.find(r => r.Name === refinerName);
        
        if (refiner) {
            const clickedEntry = refiner.Entries[refinerIndex];
            
            // If this is a parent (level 0), toggle visibility of children
            if (clickedEntry && clickedEntry.level === 0) {
                const willBeChecked = !(clickedEntry.checked || clickedEntry.fakeChecked);
                
                // If unchecking parent, remove all children from URL directly
                if (!willBeChecked) {
                    let currentFilterUrlParam = getUrlParameter(refinerName) || '';
                    
                    refiner.Entries.forEach((entry) => {
                        if (entry.parent === clickedEntry.RefinementName) {
                            entry.hidden = true;
                            
                            // Remove child from URL param if it's there
                            if (entry.checked && entry.RefinementValue) {
                                currentFilterUrlParam = currentFilterUrlParam
                                    .split(';')
                                    .filter(val => val !== entry.RefinementValue)
                                    .join(';');
                                entry.checked = false;
                            }
                        }
                    });
                    
                    // Update URL with all children removed (parent will be removed by onFilterSelected)
                    setUrlParameter(window.location.href, refinerName, currentFilterUrlParam);
                } else {
                    // Checking parent - show children
                    refiner.Entries.forEach((entry) => {
                        if (entry.parent === clickedEntry.RefinementName) {
                            entry.hidden = false;
                        }
                    });
                }
            }
        }
        
        // Call onFilterSelected for the clicked entry
        this.props.onFilterSelected(refinerName, refinerIndex);
    }

    private renderSourceToggle(isMobile: boolean) {
        if (this.props.source === undefined) {
            Log("this.props.source is undefined. Will not render Inkluder utgåtte versjoner");
            return;
        }
        return (
            <div className={`filterGroup ${isMobile ? 'mobileFilterGroup' : 'desktopFilterGroup'}`} key={`filterGroup-999`}>
                <div className="filterGroupAccordion switchSourceButton">
                    <Checkbox
                        value="include-utgatt"
                        checked={this.props.source === SearchSource.All}
                        onChange={() => this.onSourceButtonPressed()}
                    >
                        Inkluder utgåtte versjoner
                    </Checkbox>
                </div>
            </div>
        );
    }

    private toggleAccordion(accordionName: string) {
        let newOpenFilterKeys = this.state.openFilterKeys.slice();
        if (newOpenFilterKeys.indexOf(accordionName) > -1) {
            newOpenFilterKeys = newOpenFilterKeys.filter(key => key !== accordionName);
        } else {
            newOpenFilterKeys.push(accordionName);
        }
        this.setState({
            openFilterKeys: newOpenFilterKeys
        });
    }

    private isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) return false;
        }
        return true;
    }

    private onAllFiltersClicked(filterName: string) {
        this.props.onAllFilterClicked(filterName);
    }

    private onSourceButtonPressed() {
        if (!this.props.onSourceChanged) return;
        let newSource = this.props.source === SearchSource.Default ? SearchSource.All : SearchSource.Default;
        this.props.onSourceChanged(newSource);
    }
}
